import React from 'react'
import './filter.css'
import DoubleArrowRoundedIcon from '@mui/icons-material/DoubleArrowRounded';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { useNavigate } from 'react-router-dom';
import SortRoundedIcon from '@mui/icons-material/SortRounded';
import ImportExportRoundedIcon from '@mui/icons-material/ImportExportRounded';
import property1 from '../imgs/property1.jpg';
import property2 from '../imgs/property2.jpg';
import property3 from '../imgs/property3.jpg';
import property4 from '../imgs/property4.jpg';
import property5 from '../imgs/property5.jpg';
import property6 from '../imgs/property6.jpg';
import BathtubOutlinedIcon from '@mui/icons-material/BathtubOutlined';
import BedOutlinedIcon from '@mui/icons-material/BedOutlined';
import RoundedCornerOutlinedIcon from '@mui/icons-material/RoundedCornerOutlined';
import Nav from '../Nav/Nav'


const Filter = () => {
  const navigate=useNavigate("");
  function GoToInfo(){
    navigate("/info");
  }

  return (
    <div>
      <Nav/>


      <div className="Filter">
        <div className="FilterLeft">
            <div className="FilterLeft1">
               <div className="FilterTitle" id="FilterTitle" >Category</div>
                    <input type="checkbox" name="Apartment" id="apart"/>
                    <label htmlFor="apart">Apartment</label> <br/>
                    <input type="checkbox" name="Houses" id="Houses" />
                    <label htmlFor="Houses">Houses</label>   <br/>
                    <input type="checkbox" name="Rooms" id="Rooms" />
                    <label htmlFor="Rooms">Rooms</label>     <br/>
                    <input type="checkbox" name="Townhouses" id="Townhouses" />
                    <label htmlFor="Townhouses">Townhouses</label>
            </div>
            <div className="FilterLeft2">
                <span className='FilterTitle'> Price Range </span>{" "} <br/> <br/>
                <span className='FilterLeft2SubTitle'> $3,200 - $206,0000 </span>{" "}
                <Box sx={{ width: 200 }} className='slider'>
                <Slider size='small' defaultValue={3200} aria-label="Default" min={3200} max={206000} valueLabelDisplay="auto" />
                </Box>
            </div>
            <div className="FilterLeft3">
              <div className="FilterTitle">Rooms</div>
              <div className="FilterLeft3Content">
                <div className="Content1">
                  <div className="ContentTitle">Bedroom</div>
                  <select name="bed" id="bed">
                    <option value='min1' default>min</option>
                    <option value='min1'>1</option>
                    <option value='min1'>2</option>
                    <option value='min1'>3</option> 
                  </select>          
                  <span style={{color:"lightgrey"}}>— </span>     
                  <select name="bed" id="bed">
                    <option value='max1' default>max</option>
                    <option value='max1'>2</option>
                    <option value='max2'>3</option>
                    <option value='max3'>4</option>
                  </select>
                </div>
                <div className="Content2">
                  <div className="ContentTitle">Bathrooms</div>
                  <select name="bed" id="bed">
                    <option value='min1' default>min</option>
                    <option value='min1'>1</option>
                    <option value='min1'>2</option>
                    <option value='min1'>3</option> 
                  </select>           
                  <span style={{color:"lightgrey"}}>— </span>     
                  <select name="bed" id="bed">
                    <option value='max1' default>max</option>
                    <option value='max1'>2</option>
                    <option value='max2'>3</option>
                    <option value='max3'>4</option>
                  </select>
                </div>
            </div>
            </div><br/>

            <div className="FilterLeft4">
              <div className="FilterTitle">Rental Period</div>
              <div className="FilterLeft4Content">
                 <span><input type="radio" name="12m" id="" />1-12 months </span><br/>
                 <span><input type="radio" name="12m" id="" />12-24 months</span>  <br/>
                 <span><input type="radio" name="12m" id="" />24-36 months</span> <br/>
                 <span><input type="radio" name="12m" id="" />36+ months </span><br/>
              </div>
            </div>

            <div className="FilterLeft5">
               <div className="FilterTitle" id="title" >Amenties</div>
                    <input type="checkbox" name="gate" id="apart"/>
                    <label htmlFor="gate">Gated Community</label> <br/>
                    <input type="checkbox" name="Lift" id="Lift" />
                    <label htmlFor="Lift">Lift</label>   <br/>
                    <input type="checkbox" name="Pool" id="Pool" />
                    <label htmlFor="Pool">Swimming Pool</label>     <br/>
                    <input type="checkbox" name="Gym" id="Gym" />
                    <label htmlFor="Gym">Gym</label>   <br/>
                    <input type="checkbox" name="Parking" id="Parking" />
                    <label htmlFor="Parking">Parking</label>   <br/>
                    <input type="checkbox" name="Gas" id="Gas" />
                    <label htmlFor="Gas">Gas Pipeline</label>   
            </div>


            <div className="FilterLeft10">
              <span className='FilterTitle'>Sq Ft  </span>{" "} <br/> <br/>
                <span className='FilterLeft2SubTitle'> $3,200 - $206,0000 </span>{" "}
                <Box sx={{ width: 200 }} className='slider'>
                <Slider size='small' defaultValue={3200} aria-label="Default" min={3200} max={206000} valueLabelDisplay="auto" />
                </Box>
            </div>


            <div className="FilterLeft6">
              <div className="FilterTitle">Age</div>
              <div className="FilterLeft4Content">
                 <span><input type="radio" name="12m" id="" />1 year </span><br/>
                 <span><input type="radio" name="12m" id="" />2-5 years</span>  <br/>
                 <span><input type="radio" name="12m" id="" />10-20 years</span> <br/>
                 <span><input type="radio" name="12m" id="" />{'> '}20 years </span><br/>
              </div>
            </div>

            <div className="FilterLeft7">
               <div className="FilterTitle" id="title" >Added</div>
                    <input type="checkbox" name="gate" id="apart"/>
                    <label htmlFor="gate">within 1 week</label> <br/>
                    <input type="checkbox" name="Lift" id="Lift" />
                    <label htmlFor="Lift">1 - 3weeks ago</label>   <br/>
                    <input type="checkbox" name="Pool" id="Pool" />
                    <label htmlFor="Pool">{"> "}3 weeks ago</label>     <br/>
            </div>

            <div className="FilterLeft8">
              <div className="FilterTitle">Available</div>
              <div className="FilterLeft4Content">
                 <span><input type="radio" name="12m" id="" />in 10 days</span><br/>
                 <span><input type="radio" name="12m" id="" />in 30 days</span>  <br/>
                 <span><input type="radio" name="12m" id="" />in 2-4 months</span> <br/>
                 <span><input type="radio" name="12m" id="" />{'> '} 4 months </span><br/>
              </div>
            </div>

            <div className="FilterLeft9">
               <div className="FilterTitle" id="title" >Furnishing</div>
                    <input type="checkbox" name="gate" id="apart"/>
                    <label htmlFor="gate">Fully furnished</label> <br/>
                    <input type="checkbox" name="Lift" id="Lift" />
                    <label htmlFor="Lift">Semi furnished</label>   <br/>
                    <input type="checkbox" name="Pool" id="Pool" />
                    <label htmlFor="Pool">Not furnished</label> 
            </div>


            <div className="FilterLeft11">
               <div className="FilterTitle" id="title" >Lease Type</div>
                    <input type="checkbox" name="gate" id="apart"/>
                    <label htmlFor="gate">Family</label> <br/>
                    <input type="checkbox" name="Lift" id="Lift" />
                    <label htmlFor="Lift">Single</label>   <br/>
                    <input type="checkbox" name="Pool" id="Pool" />
                    <label htmlFor="Pool">Bachelor</label>     <br/>
            </div>

            <div className="FilterLeft11">
               <div className="FilterTitle" id="title" >Location</div>
                    <input type="checkbox" name="gate" id="apart"/>
                    <label htmlFor="gate">Mahim</label> <br/>
                    <input type="checkbox" name="Lift" id="Lift" />
                    <label htmlFor="Lift">Dadar</label>   <br/>
                    <input type="checkbox" name="Pool" id="Pool" />
                    <label htmlFor="Pool">Andheri</label>     <br/>
                    <input type="checkbox" name="gate" id="apart"/>
                    <label htmlFor="gate">Santacruz</label> <br/>
                    <input type="checkbox" name="Lift" id="Lift" />
                    <label htmlFor="Lift">Vile Parle</label>   <br/>
                    <input type="checkbox" name="Pool" id="Pool" />
                    <label htmlFor="Pool">Sion</label>     <br/>
                    <input type="checkbox" name="gate" id="apart"/>
                    <label htmlFor="gate">Thane</label> <br/>
            </div>

            <div className='SubmitFilter'>
              <button className="SubmitFilterButton">Apply filter</button>
            </div>
        </div>


        <div className="FilterCenter">
          <div className="FilterCenterTitle"  style={{marginLeft:"4%"}}>
            <div className="FilterTitle" style={{fontSize:"x-large"}}>Available Properties in Andheri, Mumbai</div>
            <div className="FilterCenterSubtitle">
              <span className="sub1">2148 units available</span>
              <span className="sub2">
                <ImportExportRoundedIcon style={{marginRight:"-2%",marginLeft: "16%",fontSize:'large'}}/><SortRoundedIcon style={{fontSize:'large'}}/>
                Sort by {" "}
                <select name="bed" id="bed" style={{marginLeft:"0%"}}>
                        <option value='max1' default>relevance</option>
                        <option value='max1'>price</option>
                        <option value='max2'>amenities</option>
                </select>
              </span>
            </div>
          </div>

          <div className="FilterCenterContent">
          <div className="FilterCenterContentSquare"  onClick={GoToInfo}>
                  <img src={property1} alt="" />
                  <div className="SquareInfo">
                    <div className="price">$4,058.00<span>per month</span></div><br/>
                    <div className="ApartmentName">Kohinoor Apartments</div>
                    <div className="Address">329 Kohinoor St. Andheri,Mum </div><br/>
                    <div className="GeneralInfo">
                      <span><BedOutlinedIcon  style={{color: "rgb(19 19 84)"}}/> 2 bd.</span>
                      <span><BathtubOutlinedIcon style={{color: "rgb(19 19 84)"}}/> 1 ba.</span>
                      <span><RoundedCornerOutlinedIcon style={{color: "rgb(19 19 84)"}}/> 726 sq ft.</span>
                    </div>
                  </div>
              </div>

              <div className="FilterCenterContentSquare"  onClick={GoToInfo}>
                  <img src={property2} alt="" />
                  <div className="SquareInfo">
                    <div className="price">$4,058.00<span>per month</span></div><br/>
                    <div className="ApartmentName">Kohinoor Apartments</div>
                    <div className="Address">329 Kohinoor St. Andheri,Mum </div><br/>
                    <div className="GeneralInfo">
                      <span><BedOutlinedIcon  style={{color: "rgb(19 19 84)"}}/> 2 bd.</span>
                      <span><BathtubOutlinedIcon style={{color: "rgb(19 19 84)"}}/> 1 ba.</span>
                      <span><RoundedCornerOutlinedIcon style={{color: "rgb(19 19 84)"}}/> 726 sq ft.</span>
                    </div>
                  </div>
              </div>

              <div className="FilterCenterContentSquare" onClick={GoToInfo}>
                  <img src={property3} alt="" />
                  <div className="SquareInfo">
                    <div className="price">$4,058.00<span>per month</span></div><br/>
                    <div className="ApartmentName">Kohinoor Apartments</div>
                    <div className="Address">329 Kohinoor St. Andheri,Mum </div><br/>
                    <div className="GeneralInfo">
                      <span><BedOutlinedIcon  style={{color: "rgb(19 19 84)"}}/> 2 bd.</span>
                      <span><BathtubOutlinedIcon style={{color: "rgb(19 19 84)"}}/> 1 ba.</span>
                      <span><RoundedCornerOutlinedIcon style={{color: "rgb(19 19 84)"}}/> 726 sq ft.</span>
                    </div>
                  </div>
              </div>

              <div className="FilterCenterContentSquare" onClick={GoToInfo}>
                  <img src={property4} alt="" />
                  <div className="SquareInfo">
                    <div className="price">$4,058.00<span>per month</span></div><br/>
                    <div className="ApartmentName">Kohinoor Apartments</div>
                    <div className="Address">329 Kohinoor St. Andheri,Mum </div><br/>
                    <div className="GeneralInfo">
                      <span><BedOutlinedIcon  style={{color: "rgb(19 19 84)"}}/> 2 bd.</span>
                      <span><BathtubOutlinedIcon style={{color: "rgb(19 19 84)"}}/> 1 ba.</span>
                      <span><RoundedCornerOutlinedIcon style={{color: "rgb(19 19 84)"}}/> 726 sq ft.</span>
                    </div>
                  </div>
              </div>

              <div className="FilterCenterContentSquare" onClick={GoToInfo}>
                  <img src={property5} alt="" />
                  <div className="SquareInfo">
                    <div className="price">$4,058.00<span>per month</span></div><br/>
                    <div className="ApartmentName">Kohinoor Apartments</div>
                    <div className="Address">329 Kohinoor St. Andheri,Mum </div><br/>
                    <div className="GeneralInfo">
                      <span><BedOutlinedIcon  style={{color: "rgb(19 19 84)"}}/> 2 bd.</span>
                      <span><BathtubOutlinedIcon style={{color: "rgb(19 19 84)"}}/> 1 ba.</span>
                      <span><RoundedCornerOutlinedIcon style={{color: "rgb(19 19 84)"}}/> 726 sq ft.</span>
                    </div>
                  </div>
              </div>
          </div>
        </div>


        <div className="FilterRight">
         <div className='googleMaps' id="map">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d942.2468374729383!2d72.82852007847538!3d19.15203101575131!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b6403214901f%3A0x837e8956dd36219f!2sAPARTMENT%20KOHINOOR%2C%20Milat%20Nagar%2C%20Andheri%20West%2C%20Mumbai%2C%20Maharashtra%20400047!5e0!3m2!1sen!2sin!4v1687614190377!5m2!1sen!2sin" height="450"  allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
         </div>
        </div>

      </div>
    </div>
  )
}

export default Filter